import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    logs: [],
  },
  mutations: {
    fetchStarted(state) {
      state.fetchInProgress = true
    },
    fetchStopped(state) {
      state.fetchInProgress = false
    },
    logsFetched(state, logs) {
      state.logs = logs
    },
  },
  actions: {
    async fetch({ commit }, { investorId, startupId }) {
      const url = `/investors/${investorId}/startup-logs/${startupId}`
      commit('fetchStarted')
      try {
        const request = http.getAuthed(url)
        const response = await request
        commit('logsFetched', response.data)
      } finally {
        commit('fetchStopped')
      }
    },
  },
}
